import {ActionMenuSection} from '#/components/actionmenu/types';
import {OpenMapFloatingButton} from '#/components/buttons/open-map-floating-button';
import {ExploreAndDiscover} from '#/components/home-content/explore-and-discover';
import {FooterNote} from '#/components/home-content/footer-note';
import {InjectedHomeSections} from '#/components/home-content/injected-home-sections';
import {Layout} from '#/components/layout/layout';
import {InjectedHomeLiveActivity} from '#/components/live-activity/home-live-activity';
import {TrendingMarketData} from '#/components/market-data/trending-market-data';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {Page} from '#/pages/page';
import {DefaultChildren} from '#/utils/utils';
import {Land, UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

const HomePage: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');

  const {openLandOnMap} = useQueryNavigationActions();

  const onSearch = (land: Land | UnlistedLand) => {
    openLandOnMap(land, ActionMenuSection.INFORMATION);
  };

  return (
    <Page title={t('pages.home.htmlTitle')}>
      <Layout variant='fill' onSearch={onSearch}>
        <div className='pb-6 md:pb-12 w-full h-full overflow-y-scroll relative'>
          <div className='min-h-full h-fit flex flex-col gap-y-8 md:gap-y-12 @container/home'>
            <TrendingMarketData />
            <InjectedHomeSections />
            <InjectedHomeLiveActivity />
            <ExploreAndDiscover />
            <FooterNote className='grow flex flex-col justify-end' />
          </div>

          <OpenMapFloatingButton />
        </div>
      </Layout>
    </Page>
  );
};

export default HomePage;
